import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import relativeTime from 'dayjs/plugin/relativeTime';
import 'dayjs/locale/de';

dayjs.extend(relativeTime);
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.locale('de');

export const APP_TIMEZONE = 'Europe/Berlin';
export const dayjsTZ = (date?: dayjs.ConfigType) => dayjs(date).tz(APP_TIMEZONE);

export const formatDate = (dateString: string | undefined, format: string = 'DD.MM.YYYY') => dateString && dayjs(dateString).format(format);
export const formatDateTime = (dateString: string | undefined) => dateString && dayjs(dateString).format('DD.MM.YYYY HH:mm');

// @ts-ignore
export const toNow = (dateString: string) => dayjs(dateString).fromNow();

export const getLatest = (d1: dayjs.Dayjs, d2: dayjs.Dayjs) => {
    if (d1.isAfter(d2)) return d1;
    return d2;
};

export const getEarliest = (d1: dayjs.Dayjs, d2: dayjs.Dayjs) => {
    if (d1.isBefore(d2)) return d1;
    return d2;
};

export const isInFuture = (date: string) => dayjs(date).isAfter(dayjs());
